// extracted by mini-css-extract-plugin
export default {"signUpInput":"signUp_signUpInput__IX4Uo"};